<section class="list-page">
  <!-- <div class="list-bg-shape list-bg-left" aria-hidden="true"></div>
  <div class="list-bg-shape list-bg-right" aria-hidden="true"></div> -->

  @if (isLoading) {
    <div class="spinner-overlay">
      <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" />
    </div>
  }

  @if (exportProgress() > 0) {
    <div class="export-toast">
      <div class="export-toast-left">
        <span class="export-toast-pulse" aria-hidden="true"></span>
        <div class="export-toast-text">
          <span class="export-toast-title">Generating Excel report</span>
          <span class="export-toast-sub">Please do not close the tab. This may take a moment.</span>
        </div>
      </div>
      <div class="export-toast-right">
        <div class="export-toast-bar-wrap">
          <p-progressbar styleClass="export-progress" [value]="exportProgress()" [showValue]="false"></p-progressbar>
        </div>
        <span class="export-toast-percent">{{ exportProgress() }}%</span>
      </div>
    </div>
  }

  <div class="dashboard-shell">
    <header class="dashboard-header">
      <div>
        <p class="dashboard-kicker">Insight</p>
        <!-- <h2>Monitor traffic by date, type, sender, and receiver</h2> -->
      </div>
      <button
        pButton
        type="button"
        severity="secondary"
        class="dashboard-toggle"
        [icon]="isDashboardExpanded() ? 'pi pi-angle-up' : 'pi pi-angle-down'"
        [attr.aria-expanded]="isDashboardExpanded()"
        aria-controls="dashboard-content"
        (click)="toggleDashboard()"
      ></button>
      <!-- <span class="dashboard-badge">{{ totalRecords() }} flows in view</span> -->
    </header>

    <!-- <div class="kpi-grid">
      <article class="kpi-card">
        <span class="kpi-label">Total Messages</span>
        <h3>{{ formatNumber(totalMessages()) }}</h3>
      </article>
      <article class="kpi-card">
        <span class="kpi-label">Total Payload Size</span>
        <h3>{{ formatBytes(totalSize()) }}</h3>
      </article>
      <article class="kpi-card">
        <span class="kpi-label">Average Message Size</span>
        <h3>{{ formatBytes(avgMessageSize()) }}</h3>
      </article>
      <article class="kpi-card">
        <span class="kpi-label">Unique Types</span>
        <h3>{{ byType().length }}</h3>
      </article>
    </div> -->

    @if (isDashboardExpanded()) {
      <div id="dashboard-content" class="insight-grid">
      <article class="insight-card">
        <header>
          <h4>By Date</h4>
          <span>Top days by message volume</span>
        </header>
        @for (item of byDate(); track item.label) {
          <div class="insight-row">
            <div class="insight-meta">
              <strong>{{ item.label }}</strong>
              <span>{{ formatNumber(item.value) }} messages</span>
            </div>
            <div class="insight-bar">
              <div class="insight-fill" [style.width.%]="item.percent"></div>
            </div>
          </div>
        } @empty {
          <p class="insight-empty">No data available with current filters.</p>
        }
      </article>

      <article class="insight-card">
        <header>
          <h4>By Message Type</h4>
          <span>Top message categories</span>
        </header>
        @for (item of byType(); track item.label) {
          <div class="insight-row">
            <div class="insight-meta">
              <strong>{{ item.label }}</strong>
              <span>{{ formatNumber(item.value) }} messages</span>
            </div>
            <div class="insight-bar">
              <div class="insight-fill" [style.width.%]="item.percent"></div>
            </div>
          </div>
        } @empty {
          <p class="insight-empty">No data available with current filters.</p>
        }
      </article>

      <article class="insight-card">
        <header>
          <h4>By Sender</h4>
          <span>Most active senders</span>
        </header>
        @for (item of bySender(); track item.label) {
          <div class="insight-row">
            <div class="insight-meta">
              <strong>{{ item.label }}</strong>
              <span>{{ formatNumber(item.value) }} messages</span>
            </div>
            <div class="insight-bar">
              <div class="insight-fill" [style.width.%]="item.percent"></div>
            </div>
          </div>
        } @empty {
          <p class="insight-empty">No data available with current filters.</p>
        }
      </article>

      <article class="insight-card">
        <header>
          <h4>By Receiver</h4>
          <span>Most active receivers</span>
        </header>
        @for (item of byReceiver(); track item.label) {
          <div class="insight-row">
            <div class="insight-meta">
              <strong>{{ item.label }}</strong>
              <span>{{ formatNumber(item.value) }} messages</span>
            </div>
            <div class="insight-bar">
              <div class="insight-fill" [style.width.%]="item.percent"></div>
            </div>
          </div>
        } @empty {
          <p class="insight-empty">No data available with current filters.</p>
        }
      </article>
      </div>
    }
  </div>

  <div class="filter-shell grid">
    <div class="col-12 md:col-6 lg:col-2">
      <label class="input-label">Platform</label>
      <p-iconfield>
        <p-inputicon class="pi pi-search" />
        <input type="text" pInputText placeholder="Search by platform" [(ngModel)]="filters.platform" (input)="applyFilters()" />
      </p-iconfield>
    </div>

    <div class="col-12 md:col-6 lg:col-2">
      <label class="input-label">Date Range</label>
      <p-iconfield>
        <p-inputicon class="pi pi-calendar" />
        <p-datepicker
          [(ngModel)]="filters.dateRange"
          (onSelect)="applyFiltersOnDate()"
          selectionMode="range"
          placeholder="Select date range"
          appendTo="body"
        />
      </p-iconfield>
    </div>

    <div class="col-12 md:col-6 lg:col-2">
      <label class="input-label">Message Type</label>
      <p-iconfield>
        <p-inputicon class="pi pi-search" />
        <input
          type="text"
          pInputText
          placeholder="Search message type"
          [(ngModel)]="filters.messageType"
          (input)="applyFilters()"
        />
      </p-iconfield>
    </div>

    <div class="col-12 md:col-6 lg:col-2">
      <label class="input-label">Sender</label>
      <p-iconfield>
        <p-inputicon class="pi pi-search" />
        <input type="text" pInputText placeholder="Search sender" [(ngModel)]="filters.sender" (input)="applyFilters()" />
      </p-iconfield>
    </div>

    <div class="col-12 md:col-6 lg:col-2">
      <label class="input-label">Receiver</label>
      <p-iconfield>
        <p-inputicon class="pi pi-search" />
        <input type="text" pInputText placeholder="Search receiver" [(ngModel)]="filters.receiver" (input)="applyFilters()" />
      </p-iconfield>
    </div>

    <div class="col-12 md:col-6 lg:col-2 filter-utility">
      <label class="input-label">Global Search</label>
      <p-iconfield iconPosition="left">
        <p-inputicon>
          <i class="pi pi-search"></i>
        </p-inputicon>
        <input pInputText type="text" (input)="dtModern?.filterGlobal($any($event.target).value, 'contains')" placeholder="Search all" />
      </p-iconfield>
    </div>
  </div>

  <div class="action-row">
    <button pButton label="Clear Filters" severity="secondary" (click)="clearFilters()"></button>
    <button
      pButton
      class="export-btn"
      [label]="exportProgress() > 0 ? 'Exporting...' : 'Export'"
      icon="pi pi-external-link"
      [disabled]="exportProgress() > 0"
      (click)="exportExcelWithProgress()"
    ></button>
  </div>

  <div class="table-shell desktop-view">
    <p-table
      #dtModern
      [value]="filteredData()"
      dataKey="id"
      [rows]=rowCount
      [rowsPerPageOptions]="[10, 20, 30, 50]"
      [paginator]="true"
      [globalFilterFields]="['system','messagetype','sender','receiver','messages','maxsize','size']"
      [tableStyle]="{ width: '100%' }"
      [columns]="selectedColumns"
    >
      <ng-template #caption>
        <div class="table-toolbar">
          <p-multiselect
            display="chip"
            [options]="cols"
            [(ngModel)]="selectedColumns"
            optionLabel="header"
            selectedItemsLabel="{0} columns selected"
            [style]="{ 'min-width': '220px' }"
            placeholder="Choose columns"
          />
          <span class="table-total">Total Records: <strong>{{ formatNumber(totalRecords()) }}</strong></span>
        </div>
      </ng-template>

      <ng-template #header let-columns>
        <tr>
          <th style="width: 18%">Platform</th>
          <th style="width: 16%">Date</th>
          <th style="width: 16%">Message Type</th>
          <th style="width: 16%">Sender</th>
          <th style="width: 16%">Receiver</th>
          <th *ngFor="let col of columns">{{ col.header }}</th>
        </tr>
      </ng-template>

      <ng-template #body let-data let-columns="columns">
        <tr>
          <td>{{ data.system }}</td>
          <td>{{ data.dateValue | date: 'dd-MM-yyyy' }}</td>
          <td>{{ data.messagetype }}</td>
          <td>{{ data.sender }}</td>
          <td>{{ data.receiver }}</td>
          <td *ngFor="let col of columns">{{ data[col.field] }}</td>
        </tr>
      </ng-template>

      <ng-template #emptymessage>
        <tr>
          <td colspan="8">No records found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="card-view">
    <article class="data-card" *ngFor="let item of filteredData()">
      <header class="card-header">
        <h4>{{ item.system }}</h4>
        <span>{{ item.dateValue | date: 'dd-MM-yyyy' }}</span>
      </header>

      <div class="card-grid">
        <div class="card-item">
          <span>Message Type</span>
          <strong>{{ item.messagetype }}</strong>
        </div>
        <div class="card-item">
          <span>Sender</span>
          <strong>{{ item.sender }}</strong>
        </div>
        <div class="card-item">
          <span>Receiver</span>
          <strong>{{ item.receiver }}</strong>
        </div>
        <div class="card-item">
          <span>Messages</span>
          <strong>{{ item.messages }}</strong>
        </div>
        <div class="card-item">
          <span>Maxsize</span>
          <strong>{{ item.maxsize }}</strong>
        </div>
        <div class="card-item">
          <span>Size</span>
          <strong>{{ item.size }}</strong>
        </div>
      </div>
    </article>
  </div>
</section>
